import MobileDetect from 'mobile-detect'

export const md = () => {
  const mobiledetect = new MobileDetect(window.navigator.userAgent)
  return mobiledetect;
}


// WEBPACK FOOTER //
// ./src/scripts/util.js